var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var akkuQueries = new Set([
    'akku',
    'aku',
    'accu',
    'akkutr\u00e4ger',
    'akkutrager',
    'akkutraeger',
    'akkutraher',
]);
var deviceBoosts = [
    'in_stock:true<score=16>',
    'geraetetyp:Akkutr\u00e4ger & Ger\u00e4te<score=4>',
    'kompatibilitaet:ELFA / WAVI / Tappo<score=2>',
    'product_type:-variable<score=1>',
];
// Generic device queries prioritize availability, device group and SKU sales over title matches.
var akkuRanking = ['filters', 'custom', 'typo', 'geo', 'words', 'proximity', 'attribute', 'exact'];
export function withAkkuIntentBoost(request, indexName) {
    var _a, _b, _c;
    var query = String((_b = (_a = request.params) === null || _a === void 0 ? void 0 : _a.query) !== null && _b !== void 0 ? _b : '').trim().toLowerCase();
    if (request.indexName !== indexName || !akkuQueries.has(query)) {
        return request;
    }
    var existing = (_c = request.params) === null || _c === void 0 ? void 0 : _c.optionalFilters;
    var filters = existing == null ? [] : Array.isArray(existing) ? existing : [existing];
    return __assign(__assign({}, request), { params: __assign(__assign({}, request.params), { ranking: __spreadArray([], akkuRanking, true), optionalFilters: __spreadArray(__spreadArray([], filters, true), deviceBoosts.filter(function (boost) { return !filters.includes(boost); }), true) }) });
}
